// Copyright (c) 2020 WiseTime. All rights reserved.

import { Buffer } from "buffer"

/**
 * This is a JavaScript port of our Java method LastPathEncoder#encode.
 * See: wt-access-manager-web project.
 */
const encodeLastPath = (returnPath: string): string => {
  const escapeUrl = (str: string): string =>
    str.replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=/g, "")

  const lastPath = JSON.stringify({
    app_id: "WT",
    return_path: returnPath,
  })
  return escapeUrl(Buffer.from(lastPath, "utf8").toString("base64"))
}

export default encodeLastPath

